import {useContaCommand} from '@/commandbar/commandBar.service'
import {registerRoute} from '@/router'
import BalanceReportView from '@/balrep/BalanceReportView.vue'
import {registerHotkey} from '@/hotkeys/navigationHotkeys'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {NavGroup, registerNavigationEntry} from '@/navigation'

export const BALANCE = {componentName: 'BalanceReport', component: BalanceReportView, meta: {requiresOrg: true}}

const {buildSimpleCrumb} = useBreadCrumbs()
const {registerNavigationCommand} = useContaCommand()

const icon = 'i-ph-scales-fill'
const label = 'Balanserapport'
const hotkey = 'i'
const route = BALANCE

registerNavigationCommand({
    route,
    label,
    icon,
    hotkey
})
registerNavigationEntry(NavGroup.REPORTS, {
    title: label,
    key: 'balance-report',
    icon,
    target: route,
    sortOrder: 4
})

registerRoute(route)
registerHotkey(hotkey, BALANCE)
buildSimpleCrumb(BALANCE, label, icon, true)
